export const FancyLoader = () => {
  return (
    <div className="wrapperLoader">
      <div className="box-wrap-loader">
        <div className="box-loader one"></div>
        <div className="box-loader two"></div>
        <div className="box-loader three"></div>
        <div className="box-loader four"></div>
        <div className="box-loader five"></div>
        <div className="box-loader six"></div>
      </div>
    </div>
  );
};
